/* --------------------------
 * VARIABLES GLOBALES
 * -------------------------- */
// La fecha a la que quieres contar regresivamente
var targetDate = new Date("2025/10/10 12:12:12");   

// Otras variables relacionadas con la fecha
var days;
var hrs;
var min;
var sec;

/* --------------------------
 * AL CARGAR EL DOCUMENTO
 * -------------------------- */
document.addEventListener('DOMContentLoaded', function() {
   // Calcular el tiempo hasta la fecha objetivo
   timeToLaunch();
   // Transición del contador actual desde 0 
   numberTransition('#days .number', days, 1000, 'easeOutQuad');
   numberTransition('#hours .number', hrs, 1000, 'easeOutQuad');
   numberTransition('#minutes .number', min, 1000, 'easeOutQuad');
   numberTransition('#seconds .number', sec, 1000, 'easeOutQuad');
   // Iniciar el contador
   setTimeout(countDownTimer, 1001);
});

/* --------------------------
 * CALCULAR EL TIEMPO RESTANTE
 * -------------------------- */
function timeToLaunch(){
    // Obtener la fecha actual
    var currentDate = new Date();

    // Encontrar la diferencia entre fechas en segundos
    var diff = (currentDate - targetDate) / 1000;
    diff = Math.abs(Math.floor(diff));  

    // Calcular días, horas, minutos y segundos restantes
    days = Math.floor(diff / (24 * 60 * 60));
    var leftSec = diff - days * 24 * 60 * 60;

    hrs = Math.floor(leftSec / (60 * 60));
    leftSec = leftSec - hrs * 60 * 60;

    min = Math.floor(leftSec / 60);
    sec = leftSec - min * 60;
}

/* --------------------------
 * MOSTRAR EL TIEMPO RESTANTE
 * -------------------------- */
function countDownTimer(){ 
    // Calcular el tiempo hasta la fecha objetivo
    timeToLaunch();
    
    // Actualizar el contador en la página
    document.querySelector("#days .number").textContent = days;
    document.querySelector("#hours .number").textContent = hrs;
    document.querySelector("#minutes .number").textContent = min;
    document.querySelector("#seconds .number").textContent = sec;
    
    // Repetir la función cada segundo
    setTimeout(countDownTimer, 1000);
}

/* --------------------------
 * TRANSICIÓN DE NÚMEROS DE 0
   AL TIEMPO RESTANTE
 * -------------------------- */
function numberTransition(id, endPoint, transitionDuration, transitionEase){
    var element = document.querySelector(id);
    var startValue = parseInt(element.textContent) || 0;
    var startTime = null;
    var duration = transitionDuration;
    var change = endPoint - startValue;
    var easingFunction = getEasingFunction(transitionEase);

    function animateNumber(currentTime) {
        if (startTime === null) startTime = currentTime;
        var elapsed = currentTime - startTime;
        var progress = Math.min(elapsed / duration, 1);
        var currentValue = easingFunction(elapsed, startValue, change, duration);
        element.textContent = Math.floor(currentValue);
        if (elapsed < duration) {
            requestAnimationFrame(animateNumber);
        } else {
            element.textContent = endPoint;
        }
    }

    requestAnimationFrame(animateNumber);
}

function getEasingFunction(ease) {
    if (ease === 'easeOutQuad') {
        return function (t, b, c, d) {
            t /= d;
            return -c * t * (t - 2) + b;
        };
    }
    // Función lineal por defecto
    return function(t, b, c, d) {
        return c * t / d + b;
    };
}
